// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"124":"63482b39","585":"63482b39","641":"63482b39","765":"79e08c73","780":"63482b39","814":"9483743c","889":"9483743c"}[chunkId] + ".css";
};